var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.5H4.5C4.776 7.5 5 7.724 5 8V21C5 21.276 4.776 21.5 4.5 21.5H0.5C0.224 21.5 0 21.276 0 21V8C0 7.724 0.224 7.5 0.5 7.5ZM2.48 0.5C3.85 0.5 4.96 1.619 4.96 3C4.96 4.381 3.85 5.5 2.48 5.5C1.11 5.5 0 4.381 0 3C0 1.619 1.11 0.5 2.48 0.5ZM16.5 21.5H19.5C19.776 21.5 20 21.276 20 21V12.6C20 8.83 17.87 7 14.89 7C13.701 6.957 12.55 7.418 11.72 8.27C11.572 8.441 11.313 8.46 11.142 8.312C11.051 8.233 11 8.12 11 8C11 7.724 10.776 7.5 10.5 7.5H7.5C7.224 7.5 7 7.724 7 8V21C7 21.276 7.224 21.5 7.5 21.5H10.5C10.776 21.5 11 21.276 11 21V13.5C11 12.119 12.119 11 13.5 11C14.881 11 16 12.119 16 13.5V21C16 21.276 16.224 21.5 16.5 21.5Z",
    fill: "#CCE8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.da55a6f4a2e46a1d903b38470f272960.svg";
export { ForwardRef as ReactComponent };